<template>
	<span class="number-grow-warp">
		<span ref="numberGrow" :data-time="time" class="number-grow" :data-value="value">0</span>
	</span>
</template>
 
<script>
export default {
  props: {
    time: {
      type: Number,
      default: 1
    },
    value: {
      type: Number,
      default:1000
    }
  },
  methods: {
    numberGrow (ele) {
      let _this = this
 
      let step = 60
      let current = 0
      let start = 2
      let t = setInterval(function () {
        start += step
        if (start > _this.value) {
          clearInterval(t)
          start = _this.value
          t = null
        }
        if (current === start) {
          return
        }
        current = start
        ele.innerHTML = current.toString()
      }, 120)
    }
  },
  mounted () {
    this.numberGrow(this.$refs.numberGrow)
  }
}
</script>
 
<style>
.number-grow-warp{
  transform: translateZ(0);
}
</style>
